<template>
    <div class="relative border border-gray-400 rounded-xl h-84 w-100 bg-white">
        <!-- Icon badge -->
        <div class="absolute -top-10 left-40 p-3.5 h-20 w-20 mx-auto bg-primary-800 rounded-full flex items-center justify-center">
            <LogIn class="w-9 h-9 text-white" />
        </div>

        <div class="flex h-full w-full px-4">
            <form class="pt-20 pb-4 w-full flex flex-col" @submit.prevent="onSubmit">
                <div class="space-y-1">
                    <AppInput
                        v-model="form.email"
                        :label="$t('auth.login.email')"
                        type="email"
                        autocomplete="email"
                        :error="errors.email"
                        @submit="onSubmit"
                    />
                    <AppInput
                        v-model="form.password"
                        :label="$t('auth.login.password')"
                        type="password"
                        autocomplete="current-password"
                        :error="errors.password"
                        @submit="onSubmit"
                    />
                </div>

                <div class="flex items-center mt-2">
                    <label class="flex items-center gap-2 text-sm text-gray-500 cursor-pointer select-none">
                        <input v-model="form.remember" type="checkbox" class="rounded" />
                        {{ $t('auth.login.rememberMe') }}
                    </label>
                </div>

                <p v-if="errors.general" class="text-xs text-error-500 mt-2">{{ errors.general }}</p>

                <div class="mt-auto w-full">
                    <AppButton :loading="loading" @click="onSubmit">
                        {{ $t('auth.login.submit') }}
                    </AppButton>
                </div>
            </form>
        </div>
    </div>
</template>

<script setup lang="ts">
import { reactive, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { LogIn } from 'lucide-vue-next';
import AppInput from '@/components/ui/AppInput.vue';
import AppButton from '@/components/ui/AppButton.vue';
import Authentication from '@/plugins/authentication';

const router = useRouter();
const { t } = useI18n();

const form = reactive({ email: '', password: '', remember: true });
const errors = reactive({ email: '', password: '', general: '' });
const loading = ref(false);

async function onSubmit() {
    errors.email = '';
    errors.password = '';
    errors.general = '';

    if (!form.email) { errors.email = t('auth.login.required'); return; }
    if (!form.password) { errors.password = t('auth.login.required'); return; }

    loading.value = true;
    try {
        await Authentication.login({ email: form.email, password: form.password, remember: form.remember });
        router.push('/account/profile');
    } catch {
        errors.general = t('auth.login.invalidCredentials');
    } finally {
        loading.value = false;
    }
}
</script>
